import {decorate, action, observable} from "mobx";
import {dataFetcher} from "../helpers/DataFetcher";

export default class StyleStore{

  url = process.env.REACT_APP_PORTAL_URL + '/layoutparts_rl/default/default/';

  headerHtml;
  Css;
  footerHtml;
  layoutPartsJS;

  setData = (data) => {
    this.headerHtml = data.templates.header;
    this.Css = data.styles.responsive.all;
    this.footerHtml = data.templates.footer;
    this.layoutPartsJS = data.scripts.all
  };

  async fetch(){

    const ret = await dataFetcher.fetchUrl(this.url);
    if (ret.data){
      this.setData(ret.data);
    }
  }
}

decorate(StyleStore, {
  headerHtml: observable,
  Css: observable,
  footerHtml: observable,
  layoutPartsJS: observable,
  setData: action
});
